import { render, staticRenderFns } from "./ticker.component.vue?vue&type=template&id=d9e0afbc"
import script from "./ticker.component.vue?vue&type=script&lang=js"
export * from "./ticker.component.vue?vue&type=script&lang=js"
import style0 from "./ticker.component.vue?vue&type=style&index=0&id=d9e0afbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports